import { useEffect } from 'react';
import { FormatTypes, format, formatFileSize, isDateTimeType } from '../../../Lib/Format';
import toNumberOrNull from '../../../Lib/toNumberOrNull';
import { withInjectedProps } from '../InjectedPropsContext';

interface IFormattedTextProps {
  format?: any;
  name?: string;
  value?: any;
  comparisonSymbol?: string | undefined;
  hasValueCallback?: (_: boolean) => void;
  blankReplacement?: string | null;
}

// Outputs text of value formatted with the given format
// Allows us to retrieve strings from these using prop injection.
let FormattedText: React.FC<IFormattedTextProps> = ({
  format: formatSpecifier,
  value,
  hasValueCallback,
  blankReplacement = null,
  comparisonSymbol,
}) => {
  let displayedValue = value;

  // Format numbers & dates
  if (formatSpecifier && typeof displayedValue === 'boolean') {
    displayedValue = format(formatSpecifier)(displayedValue);
  } else if (
    formatSpecifier &&
    formatSpecifier.type === FormatTypes.FileSize &&
    (typeof displayedValue === 'string' || typeof displayedValue === 'number')
  ) {
    displayedValue = formatFileSize(displayedValue);
  } else if (
    formatSpecifier &&
    (typeof displayedValue === 'string' || typeof displayedValue === 'number' || displayedValue instanceof Date)
  ) {
    if (!isDateTimeType(formatSpecifier.type)) displayedValue = toNumberOrNull(displayedValue);
    displayedValue = format(formatSpecifier)(displayedValue);
    if (!!comparisonSymbol) displayedValue = `${comparisonSymbol}${displayedValue}`;
  }

  const hasValue = displayedValue || displayedValue === 0;

  useEffect(() => {
    hasValueCallback && hasValueCallback(hasValue);
  }, [hasValueCallback, hasValue]);

  return hasValue ? displayedValue : blankReplacement;
};

FormattedText = withInjectedProps(FormattedText);

export { FormattedText };
export default FormattedText;
